import { createFileRoute } from '@tanstack/react-router'
import { HomePage } from '../components/home-page'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/')({
  loader: () => loadPageData({ data: { kind: 'home', locale: 'en' } }),
  head: () => staticRouteHead('home', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <HomePage />
    </CatalogProvider>
  )
}
